import { useTranslation } from 'react-i18next';
import { I18N_KEYS } from '@/language/keys';
import { WAFBlockingDialog } from '@/UI/WAFFailureModal/WAFBlockingDialog';

interface WAFSlowNoticeStandaloneProps {
  onReload: () => void;
  isEmbedded?: boolean;
}

// Always offers the browser-help link: a solve that stays slow is commonly an extension or network filter
// interfering with the challenge.
export function WAFSlowNoticeStandalone({ onReload, isEmbedded = false }: WAFSlowNoticeStandaloneProps) {
  const { t } = useTranslation();
  return (
    <WAFBlockingDialog
      title={t(I18N_KEYS.SECURITY_CHALLENGE.SLOW_NOTICE_TITLE)}
      body={t(I18N_KEYS.SECURITY_CHALLENGE.SLOW_NOTICE_BODY)}
      showBrowserHelp
      onReload={onReload}
      isEmbedded={isEmbedded}
    />
  );
}
